import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import styles from './PdpSharedDealerInfo.scss';

function PdpSharedDealerInfo({ seller }) {
    const dealerSince = new Date(get(seller, 'agreementStart')).getUTCFullYear();
    const dealerLocation = get(seller, 'shippingAddress.displayCityStateCountry');
    const responseTime = get(seller, 'analytics.metrics.responseTime.displayValue');
    const tradeAssociations = get(seller, 'tradeAssociations');

    return (
        <Fragment>
            {dealerSince && (
                <div>
                    <FormattedMessage
                        id="PdpSharedDealerInfo.since"
                        defaultMessage="1stdibs seller since {dealerSince}"
                        values={{ dealerSince }}
                    />
                </div>
            )}
            {responseTime && (
                <div>
                    <FormattedMessage
                        id="PdpSharedDealerInfo.response_time"
                        defaultMessage="Typical response time: {responseTime}"
                        values={{ responseTime }}
                    />
                </div>
            )}
            {dealerLocation && (
                <div>
                    <FormattedMessage
                        id="PdpSharedDealerInfo.location"
                        defaultMessage="Located in {dealerLocation}"
                        values={{ dealerLocation }}
                    />
                </div>
            )}
            {tradeAssociations.length ? (
                <div className={styles.associations}>
                    <FormattedMessage
                        id="PdpSharedDealerInfo.associations"
                        defaultMessage="Associations:"
                    />
                    {tradeAssociations.map(({ serviceId, displayName }) => {
                        return <div key={serviceId}>{displayName}</div>;
                    })}
                </div>
            ) : null}
        </Fragment>
    );
}

PdpSharedDealerInfo.propTypes = {
    seller: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDealerInfo, {
    seller: graphql`
        fragment PdpSharedDealerInfo_seller on Seller {
            agreementStart
            shippingAddress {
                displayCityStateCountry
            }
            analytics {
                metrics {
                    responseTime {
                        displayValue
                    }
                }
            }
            tradeAssociations {
                serviceId
                displayName
            }
        }
    `,
});
